import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-cyan-900 text-white text-sm">
      <div className="container mt-10 mx-auto py-6">
        <div className="my-5 grid grid-cols-1 md:grid-cols-3 gap-4 justify-items-center">
          <div className="md:justify-self-start">
            <div className="-ml-2">
              <a href="https://www.goracle.io/contact" target="_blank" rel="noreferrer">
                <img
                  className="object-cover w-40"
                  src="/images/Goracle_Large_Navy_Horiz.png"
                  alt="Company logo" />
              </a>
            </div>
          </div>
          <div>
            <p className="my-2 font-semibold text-lg">Quick Links</p>
            <p className="mt-2"><a href="https://www.goracle.io/support" className="hover:text-lime-500">Support</a></p>
            <p className="mt-2"><a href="https://www.goracle.io/blog" className="hover:text-lime-500">Blog</a></p>
          </div>
          <div className="md:justify-self-end">
            <p className="my-2 font-semibold text-lg">Follow Us:</p>
            <div className="flex flex-wrap items-center justify-between gap-4">
              <a className="hover:text-lime-500" href="https://twitter.com/algoracle" aria-label="twitter handle">
                <i className="fab fa-twitter text-lg"></i>
              </a>
              <a className="hover:text-lime-500" href="https://www.linkedin.com/company/algoracle" aria-label="twitter handle">
                <i className="fab fa-linkedin text-lg"></i>
              </a>
              <a className="hover:text-lime-500" href="https://discord.gg/Pe8rwyPvKp" aria-label="twitter handle">
                <i className="fab fa-discord text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <hr />

        <div className="mt-5 flex justify-center">
          &copy; {new Date().getFullYear()} Goracle. All rights reserved.
        </div>
      </div>
    </footer>
  )
}
